import { HttpService } from 'src/services';
import { Benefit, BenefitDto, BenefitId, BenefitModel } from 'src/models/Benefit/Benefit';

const BenefitsService = {
  getMany: (): Promise<Benefit[]> => HttpService
    .get<BenefitDto[]>('/public/benefits')
    .then(items => items.map(BenefitModel.fromDto)),

  getOne: (id: BenefitId): Promise<Benefit> => HttpService
    .get<BenefitDto>(`/public/benefits/${id}`)
    .then(BenefitModel.fromDto),
};

export default BenefitsService;
